import React, { useEffect } from 'react';
import { Flex, Skeleton, Tag, Typography } from 'antd';
import ReactMarkdown from 'react-markdown';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import { GenericModal } from '../../../../../shared/ui/GenericModal';
import { useLazyReadRecommendationQuery } from '../service/recommendations-ai.api';
import { useAppSelector } from '../../../../../store';
import { selectCurrentRecommendation } from '../store/recommendationAISlice';

const { Text } = Typography;

export const RecommendationsHistoryContainer = () => {
    const navigate = useNavigate();
    const currentRecommendation = useAppSelector(selectCurrentRecommendation);

    const [getRecommendation, { data, isLoading, isFetching }] =
        useLazyReadRecommendationQuery();

    useEffect(() => {
        if (currentRecommendation) {
            getRecommendation(currentRecommendation.id, true);
        }
    }, [currentRecommendation]);

    const handleCopyRecommendation = () => {
        void navigator.clipboard.writeText(JSON.stringify(data));
    };

    if (!currentRecommendation) return;

    return (
        <GenericModal
            onCancel={() => navigate(-1)}
            width={720}
            okText={'Скопировать'}
            onConfirm={handleCopyRecommendation}
            cancelText={'Закрыть'}
            open
            title={'История'}
        >
            <Flex
                style={{
                    marginTop: '16px',
                }}
                vertical
                gap={24}
            >
                <Flex vertical gap={8}>
                    <Text>Сообщества</Text>
                    <Flex
                        vertical={false}
                        style={{
                            flexWrap: 'wrap',
                        }}
                    >
                        {currentRecommendation.communities.map(community => (
                            <Flex key={community.id} vertical={false}>
                                <Tag>{community.title}</Tag>
                            </Flex>
                        ))}
                    </Flex>
                </Flex>

                <Flex vertical gap={8}>
                    <Text>Рекомендации</Text>
                    {isLoading || isFetching ? (
                        <Skeleton />
                    ) : (
                        data?.map((recommendation, index) => (
                            <Flex vertical key={index}>
                                {dayjs(recommendation.created_at).format(
                                    'DD.MM.YY'
                                )}
                                <ReactMarkdown>
                                    {recommendation.text}
                                </ReactMarkdown>
                            </Flex>
                        ))
                    )}
                </Flex>
            </Flex>
        </GenericModal>
    );
};
